import favicon from '@resources/images/vatit/vatit_favicon-192x192.png';
import VFileLogo from '@resources/svgs/logos/vFile_logo.svg';
import VSuiteLogo from '@resources/svgs/logos/vSuite_logo.svg';
import { vfileRoutes } from '@routes/vfile';
import { vsuiteRoutes } from '@routes/vsuite';

import type { ExtendedAppConfig } from '../baseConfig';

export const vatitConfig: ExtendedAppConfig = {
  company: {
    address: '54 Melrose Boulevard, Melrose Arch, Melrose North, 2196, Johannesburg, South Africa',
    name: 'VAT IT',
    registeredCountry: 'South Africa',
    registeredName: 'VAT IT Reclaim',
  },
  favicon,
  legalEmail: 'legal@vatit.com',
  supportEmail: 'support@vatit.com',
  contractualClausesUrl: 'https://www.vatglobal.com/standard-contractual-clauses',
  vfile: {
    logo: VFileLogo,
    name: 'vfile',
    url: vfileRoutes.FILING_LIST.make(),
  },
  vsuite: {
    logo: VSuiteLogo,
    name: 'vsuite',
    url: vsuiteRoutes.DASHBOARD.make(),
  },
};
